export const buildWhatsappHref = (rawNumber, message) => {
  const number = String(rawNumber || '').replace(/\D/g, '');
  if (!number) return null;

  const base = `https://wa.me/${number}`;
  return message && message.trim()
    ? `${base}?text=${encodeURIComponent(message.trim())}`
    : base;
};

export const getFloatingWhatsappHref = (companyInfo, whatsappOverride = '', header = null) => {
  const fromHeader = header?.contactMenu?.items?.find((entry) => entry?.type === 'whatsapp');

  if (whatsappOverride) {
    return buildWhatsappHref(whatsappOverride, fromHeader?.whatsappMessage);
  }

  if (fromHeader?.value) {
    return buildWhatsappHref(fromHeader.value, fromHeader.whatsappMessage);
  }

  const fromContact = companyInfo?.contactInfo?.find((entry) => entry?.type === 'whatsapp');
  if (fromContact?.value) {
    return buildWhatsappHref(fromContact.value);
  }

  const fromSocial = companyInfo?.socialMedia?.find((entry) => entry?.platform === 'whatsapp');
  if (!fromSocial?.url) return null;

  if (fromSocial.url.includes('wa.me') || fromSocial.url.includes('whatsapp.com')) {
    return fromSocial.url;
  }

  const match = fromSocial.url.match(/(\d[\d\s\-+()]+)/);
  return match ? buildWhatsappHref(match[1]) : fromSocial.url;
};

export const isFloatingWhatsappEnabled = (companyInfo) => (
  companyInfo?.chatbot?.whatsappFlotante === true
  || companyInfo?.chatbot?.whatsappflotante === true
);
